module.exports = __webpack_public_path__ + "img/code1.92a6e786.png";